import {
    FETCH_PHONE_CARDS,
    FETCH_PHONE_CARDS_SUCCESS,
    FETCH_PHONE_CARDS_FAILED
} from "../store/types";

export const INITIAL_STATE = {
    cards: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const phonecardreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_PHONE_CARDS:
            return {
                ...state,
                loading: true
            };
        case FETCH_PHONE_CARDS_SUCCESS:
            return {
                ...state,
                cards: action.payload,
                loading: false,
                error: { flag: false, msg: null }
            };
        case FETCH_PHONE_CARDS_FAILED:
            return {
                ...state,
                cards: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        default:
            return state;
    }
};
